export const TWITTER_LABEL = 'X (Twitter)'
